import { GoogleSearchClient } from '@jbhi-fi/apis/src/googleSearch';
import { GoogleSuggestionsClient } from '@jbhi-fi/apis/src/googleSuggestions';
import { serviceHelper } from '../../config/service-helper';

let _searchClient: GoogleSearchClient | null = null;
let _suggestionsClient: GoogleSuggestionsClient | null = null;

export const getSearchClient = (): GoogleSearchClient => {
  if (!_searchClient) {
    _searchClient = new GoogleSearchClient({
      onlineSearchApiUrl: serviceHelper.onlineSearchApiUrl ?? '',
      onlineSearchApiKey: serviceHelper.onlineSearchApiKey ?? '',
      countryCode: window.Jbhifi?.storeLocation || 'AU',
    });
  }
  return _searchClient;
};

export const getSuggestionsClient = (): GoogleSuggestionsClient => {
  if (!_suggestionsClient) {
    _suggestionsClient = new GoogleSuggestionsClient({
      googleSuggestionsApiUrl: serviceHelper.googleSuggestionsApiUrl ?? '',
    });
  }
  return _suggestionsClient;
};
